import { AccountView } from "@daveyplate/better-auth-ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/$accountView")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Account" }],
  }),
});

function RouteComponent() {
  const { accountView } = Route.useParams();
  return <AccountView pathname={accountView} />;
}
